import Vue from 'vue'
import AuthService from '../../../service/auth.js'

export default {
  'data': function () {
    return {
      data: {
        user: Object.assign({}, AuthService.getUser()),
        isUpdated: null
      }
    }
  },
  'methods': {
    salva () {
      Vue.http.post('auth/user', this.data.user).then(() => {
        AuthService.setUser(this.data.user)
        this.data.isUpdated = true
      }, function () {
        this.data.isUpdated = false
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/area-riservata/area-riservata-profile/area-riservata-profile.js